import { FC } from 'react'

import { getTaskStatusLabel } from './getTaskStatusLabel'

export interface TaskStatusLabelProps {
  name: string
}

export const TaskStatusLabel: FC<TaskStatusLabelProps> = ({ name }) => <span>{getTaskStatusLabel(name)}</span>
